const TripEmptyState = ({
  title = '',
  description = '',
  className = '',
  button = null,
}) => {
  return (
    <div className={`flex h-full ${className}`}>
      <div className="m-auto py-16 md:py-0 lg:py-0 xl:py-0 text-center w-8/12 sm:w-10/12 md:w-10/12 lg:w-7/12">
        <img className="mx-auto" src="/images/truck.svg" />
        <h1 className="font-semibold mt-6 text-xl">{title}</h1>
        <p className="mt-4 text-xs text-gray-600">{description}</p>
        <div className="mt-6">{button}</div>
      </div>
    </div>
  );
};

export default TripEmptyState;
